<template>
  <settings-page-card
    title="General Settings"
  >
    <b-form @submit.prevent="onSubmit">
      <div class="px-4">
        <div class="max-w-[600px]">
          <b-form-group>
            <slot name="label">
              <h6 class="font-weight-sami-bold text-dark">
                Project Name
              </h6>
            </slot>
            <b-input
              v-model="projectName"
              v-validate="'required'"
              name="name"
              :state="errors.has('name') ? false : null"
              :readonly="!canUpdateGeneralSettings"
            />
          </b-form-group>

          <b-form-group>
            <slot name="label">
              <h6 class="font-weight-sami-bold text-dark">
                Project Description
              </h6>
            </slot>
            <b-textarea
              v-model="project.description"
              rows="4"
              :readonly="!canUpdateGeneralSettings"
            />
          </b-form-group>

          <b-form-group v-show="false">
            <slot name="label">
              <h6 class="font-weight-sami-bold text-dark">
                Subdomain
              </h6>
            </slot>
            <b-input
              v-model="subdomain"
              v-validate="'required'"
              name="subdomain"
              :state="errors.has('subdomain') ? false : null"
              :readonly="!canUpdateGeneralSettings"
            />
          </b-form-group>

          <b-form-group>
            <slot name="label">
              <h6 class="font-weight-sami-bold text-dark">
                Timezone
              </h6>
            </slot>
            <v-select
              v-model="project.timezone"
              :options="timezoneOptions"
              label="name"
              class="w-full"
              :reduce="val => val.value"
              :readonly="!canUpdateGeneralSettings"
              searchable
            />
          </b-form-group>
        </div>

        <hr class="my-4">

        <favicon-uploader
          class="mb-4"
          :readonly="!canUpdateGeneralSettings"
        />

        <b-btn
          v-if="canUpdateGeneralSettings"
          variant="primary"
          type="submit"
        >
          Save Changes
        </b-btn>
      </div>
    </b-form>
  </settings-page-card>
</template>

<script>
import _ from 'lodash'
import {mapGetters, mapState} from 'vuex'
import SettingsPageCard from '../../layouts/dashboard/SettingsPageCard'
import FaviconUploader from '../../components/editor/controls/FaviconUploader'
import TimezonesMixin from '@/components/mixins/TimezonesMixin'

export default {
  name: 'GeneralSettings',

  components: {
    FaviconUploader,
    SettingsPageCard
  },

  mixins: [TimezonesMixin],

  computed: {
    ...mapState('projects', {
      project: state => state.project
    }),
    ...mapGetters('projects', {
      checkPermissions: 'checkPermissions'
    }),
    canUpdateGeneralSettings () {
      return this.checkPermissions('project_settings.general.update')
    },
    projectName: {
      get () {
        return this.project.name
      },
      set (val) {
        this.project.name = val
      }
    },
    subdomain: {
      get () {
        return this.project.subdomain
      },
      set (val) {
        this.project.subdomain = _.kebabCase(val)
      }
    },
    timezoneOptions () {
      const items = this.timezones.map(tz => {
        const name = tz.replace(/.+\/([^/_]+(?:_[^/_]+)*)$/, (match, p1) => {
          return p1.replace(/_/g, ' ')
        })

        return {
          value: tz,
          name
        }
      })

      const counts = items.reduce((acc, { name }) => {
        acc[name] = (acc[name] || 0) + 1
        return acc
      }, {})

      return items
        .map(item => {
          if (counts[item.name] > 1 && item.value.includes('/')) {
            const region = item.value.split('/').slice(0, -1).join('/')
            return { ...item, name: `${item.name} (${region})` }
          }
          return item
        })
        .sort((a, b) => a.name.localeCompare(b.name))
    }
  },

  methods: {
    onSubmit () {
      this.$validator.validateAll().then((result) => {
        if (result) {
          VEvent.fire('loader', true)
          this.$store.dispatch('projects/save', {}, { root: true })
            .then(() => {
              this.$swal({
                icon: 'success',
                iconColor: '#4F83E3',
                toast: true,
                position: 'top-right',
                title: 'Success',
                showConfirmButton: false,
                timer: 3000
              })
            })
            .catch(errors => {
              const arrErrors = Object.keys(errors.response.data.errors),
                errorMsg = arrErrors.length ? errors.response.data.errors[Object.keys(errors.response.data.errors)[0]] : errors.response.data.message

              this.$swal({
                icon: 'error',
                iconColor: '#4F83E3',
                toast: true,
                position: 'top-right',
                title: errorMsg,
                showConfirmButton: false,
                timer: 3000
              })
            })
            .finally(() => {
              VEvent.fire('loader', false)
            })
        }
      })
    }
  },
  async mounted () {
    await this.$store.dispatch('projects/hasAccessToPage', 'project_settings.general')
  }
}
</script>
